document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.select_collection-blocks');
    if (!container) return;

    // Try to find default
    let selected =
        container.querySelector('.tag_item[data-default="true"]') ||
        container.querySelector('.tag_item');

    if (!selected) return;

    // Clear existing
    container.querySelectorAll('.tag_item')
        .forEach(el => el.classList.remove('convx__collection-selected-btn'));

    // Set selected
    selected.classList.add('convx__collection-selected-btn');
});

document.addEventListener('DOMContentLoaded', () => {
    const scrollLink = document.getElementById('scroll-link');
    if (!scrollLink) return; // ✅ prevent crash

    scrollLink.addEventListener('click', function (e) {
        e.preventDefault(); // stop default jump

        const targetEl = document.getElementById('convx__collection-products');
        if (!targetEl) return;

        const offset = 150;
        const topPos =
            targetEl.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
            top: topPos,
            behavior: 'smooth',
        });
    });
});

document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', function () {
    const dropdown = document.getElementById('customSortDropdown');
    const selected = dropdown.querySelector('.selected');
    const options = dropdown.querySelectorAll('.dropdown-options li');
    const hiddenSelect = document.getElementById('SortBy');

    selected.addEventListener('click', () => {
        dropdown.classList.toggle('open');
    });

    options.forEach((option) => {
        option.addEventListener('click', () => {
            const value = option.getAttribute('data-value');
            const text = option.textContent;

            selected.textContent = text;
            hiddenSelect.value = value;

            // 🟡 Trigger the 'change' event so Shopify or your function detects it
            hiddenSelect.dispatchEvent(new Event('change'));

            dropdown.classList.remove('open');
        });
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
            dropdown.classList.remove('open');
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.convx__collection-blocks');
    const bar = section?.querySelector('.select_collection-blocks');
    if (!section || !bar) return;

    // spacer prevents layout jump
    const spacer = document.createElement('div');
    spacer.className = 'convx__bar-spacer';
    bar.parentNode.insertBefore(spacer, bar);

    const getHeaderOffset = () => {
        const header = document.querySelector('.site-header, .shopify-section-header, header.sticky, .header, header');
        if (!header) return 56;
        const pos = getComputedStyle(header).position;
        return pos === 'sticky' || pos === 'fixed' ? header.getBoundingClientRect().height : 56;
    };

    let sectionTop = 0;
    let headerOffset = 0;
    let fixed = false;

    function measure() {
        headerOffset = getHeaderOffset();
        const rect = section.getBoundingClientRect();
        sectionTop = rect.top + window.pageYOffset;
        if (fixed) lockBar(); // keep alignment if already fixed
    }

    function lockBar() {
        // lock current width/left so it doesn't jump
        const r = bar.getBoundingClientRect();
        bar.style.setProperty('--fix-left', r.left + window.scrollX + 'px');
        bar.style.setProperty('--fix-width', r.width + 'px');
        bar.style.top = headerOffset + 'px';
        spacer.style.setProperty('--bar-h', r.height + 'px');
    }

    function onScroll() {
        const y = window.pageYOffset || document.documentElement.scrollTop || 0;
        const shouldFix = y >= sectionTop - headerOffset;

        if (shouldFix && !fixed) {
            lockBar(); // lock dims first
            bar.classList.add('is-fixed');
            spacer.classList.add('active');
            fixed = true;
        } else if (!shouldFix && fixed) {
            bar.classList.remove('is-fixed');
            spacer.classList.remove('active');
            fixed = false;
        }
    }

    // rAF scroll loop = no flicker, minimal work
    let ticking = false;
    window.addEventListener(
        'scroll',
        () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    onScroll();
                    ticking = false;
                });
                ticking = true;
            }
        },
        { passive: true }
    );

    window.addEventListener(
        'resize',
        () => {
            measure();
            onScroll();
        },
        { passive: true }
    );

    window.addEventListener('load', () => {
        measure();
        onScroll();
    });

    // initial
    measure();
    onScroll();
});

document.addEventListener('DOMContentLoaded', () => {
    // Mobile only
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    const container = document.querySelector('.select_collection-blocks');
    if (!container) return;

    // Ensure there's a selected item; fall back to first
    let selected =
        container.querySelector('.tag_item.convx__collection-selected-btn') || container.querySelector('.tag_item');
    if (!selected) return;
    selected.classList.add('convx__collection-selected-btn');

    // Start collapsed
    container.classList.remove('expanded');

    // Click behavior
    container.addEventListener('click', (e) => {
        const item = e.target.closest('.tag_item');
        if (!item) return;

        const isExpanded = container.classList.contains('expanded');
        const isSelected = item.classList.contains('convx__collection-selected-btn');
        var elem = document.getElementById('collection-title');
        // Tap the selected tag → toggle expanded (show all / collapse)
        if (isSelected) {
            if (elem) {
                elem.scrollIntoView();
            }
            container.classList.toggle('expanded');
            return;
        }

        // Tap a different tag:
        // 1) make it selected
        container.querySelectorAll('.tag_item').forEach((i) => i.classList.remove('convx__collection-selected-btn'));
        item.classList.add('convx__collection-selected-btn');

        // 2) collapse back to only that one
        container.classList.remove('expanded');
    });
});
